export default {
    CLIENT: "wsfb2022",
    API_NAME: "wsf-api-wsfb2022",
    API_BASE_URL: "https://ar3hlbdmpb.execute-api.ap-southeast-2.amazonaws.com/wsfb2022",
    S3_BASE_URL: "https://events-public-assets.s3.ap-southeast-2.amazonaws.com/events/wsfb2022",
    BITMOVIN_ANALYTICS_KEY: "ade734cd-842a-4308-b630-9d3c3b709ce0",
    BACKEND_REGION: "ap-southeast-2",
}